var WStationViewModal = (function (base) {
  __extends(WStationViewModal, base);

  function WStationViewModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };

  WStationViewModal.prototype.activate = function (wstationId, deleteFunc, showOnMapFunc) {
    const self = this;
    const url = 'api/wstations/{0}'.format(wstationId);

    this.loadContent(url)
      .then($modal => {

        $modal

          .on('click', '[js=edit]', function () {
            ModalConductor.activate(WStationEditModal, wstationId)
              .on('closed', (modalResult) => {
                if (modalResult.ok) {
                  self.reloadContent(url);
                }
              });
          })

          .on('click', '[js=delete]', function () {
            if (confirm('Вы действительно хотите удалить эту метеоситуацию?')) {
              deleteFunc(wstationId);
            }
          })

          .on('click', '[js=show-on-map]', function () {
            showOnMapFunc(wstationId);
          })

          .on('click', '[js=show-history]', function () {
            const wstationName = $('[data-binding=Name]', $modal).text();
            ModalConductor.activate(WStationHistoryModal, wstationId, wstationName);
          });
      });
  };

  return WStationViewModal;
}(BaseModal));
